import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Profile from './pages/Profile';
import Login from './pages/Login';
import Arena from './pages/Arena';
import ShopPage from './pages/ShopPage';
import BazzarPage from './pages/BazzarPage';
import GuildIndex from './components/Guild/GuildIndex';
import TradePage from './pages/TradePage';

function App() {
  const particles = Array.from({ length: 50 });
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/login" element={<Login />} />
          <Route path="/arena" element={<Arena />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/bazzar" element={<BazzarPage />} />
          <Route path="/trade" element={<TradePage />} />
          <Route path="/guild" element={<GuildIndex />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
